/** Presentation only: standard browser button indices never change with the
 * controller's branding. An ambiguous "Wireless Controller" remains generic.
 */
const GENERIC=Object.freeze({family:"generic",confirm:"A",back:"B",weapon:"RT",power:"LT",menu:"Menu / Start"});
const PLAYSTATION=Object.freeze({family:"playstation",confirm:"X",back:"○",weapon:"R2",power:"L2",menu:"Options"});
export function gamepadPrompts(id:string){
  return /dual\s*sense|dual\s*shock|playstation|\bsony\b|\bvendor\s*:\s*054c\b|\b054c[-:]/i.test(id)
    ?PLAYSTATION:GENERIC;
}
